export default __webpack_public_path__ + "static/ronaldo-xs-c80e3c672ec0eb51bdf10e470d5529e9.png";